var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gc-footer-scan-barcode"},[_c('i',{class:_vm.iconClass}),_c('span',{staticClass:"gc-footer-label"},[_vm._v(_vm._s(_vm.labelText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }